import React,{useEffect,useState} from 'react';
import { withRouter,useHistory } from 'react-router-dom';
import Wrapper from '../../../components/Wrapper/Wrapper';
import { DataGrid } from '@material-ui/data-grid';
import { connect } from "react-redux";
import { logoutUser } from "../../../../store/actions/authActionCreators";
import {updatePartyTab,getPartyDetails} from  "../../../../store/actions/partiesActionCreator";
import MUIDataTable from "mui-datatables";
import * as logger from "../../../../logger";
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import InputAdornment from '@material-ui/core/InputAdornment';
import SearchIcon from '@material-ui/icons/Search';
import {numberFormat} from '../../../../utils/utils'
import Button from '@material-ui/core/Button';
import AddIcon from '@material-ui/icons/Add';
import Grid from '@material-ui/core/Grid';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import useStyles from '../../css/listing'
import NavigationTabs from '../../../components/Tabs/NavigationTabs';
import TabsPageLayout from '../../../components/PageLayout/TabsPageLayout'
import Configs from '../PartyConfigs';
const ViewParty = ({user,parties,location,dispatchTabUpdate,dispatchGetPartyDetails}) => {
  const classes = useStyles();
  let history = useHistory();
  let path = location && location.pathname ? location.pathname.split("/") : [];
  let partyId = "";
  if (path[path.length - 1]) {
    partyId = path[path.length - 1];
  }
  useEffect(()=>{
    //if(parties && parties.details && parties.details.customerId &&  parties.details.customerId != partyId){
    dispatchGetPartyDetails(partyId,()=>{

    },()=>{

    })
  },[])
  let onTabChange = (value)=>{
    dispatchTabUpdate(value);
  }
  return (<Wrapper>
    <TabsPageLayout>
      <NavigationTabs tabs={Configs.tabs} defaultSelected={parties && parties.partyViewTab?parties.partyViewTab:0} onChange={onTabChange}>
      </NavigationTabs>
    </TabsPageLayout>
  </Wrapper>);
};
const mapStateToProps = (state) => (state);
const mapDispatchToProps = (dispatch) => ({
  dispatchLogoutAction: () => dispatch(logoutUser()),
  dispatchGetPartyDetails: (id, onSuccess, onFailure) => {
      dispatch(getPartyDetails(id, onSuccess, onFailure))
  },
  dispatchTabUpdate: (value) => dispatch(updatePartyTab(value))
});
const ViewPartyWithRouter = withRouter(ViewParty);
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ViewPartyWithRouter);